// Phase 5.1 — fixed-bottom selection footer for the map's
// «выбрать на карте» mode.
//
// Shows the current selection count and the two action buttons.
// «Готово» commits the array back to BatchModal's textarea via
// the `onConfirm` callback; «Отмена» drops the picker without
// touching the textarea. Selected codes preview is capped — if
// more than 5 are selected, we truncate to «AMC4, POTS, WTZR
// + ещё N» so the footer doesn't wrap unpredictably on a
// 360-px Telegram WebView.

import './MapSelectionFooter.css';

const PREVIEW_CAP = 5;

interface Props {
  selected: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function MapSelectionFooter({
  selected,
  onConfirm,
  onCancel,
}: Props) {
  const preview =
    selected.length <= PREVIEW_CAP
      ? selected.join(', ')
      : `${selected.slice(0, PREVIEW_CAP).join(', ')} + ещё ${
          selected.length - PREVIEW_CAP
        }`;

  return (
    <footer
      className="map-selection-footer"
      data-testid="map-selection-footer"
    >
      <div className="map-selection-summary">
        <span className="map-selection-label">Выбрано</span>
        <span
          className="map-selection-codes"
          data-testid="map-selection-codes"
        >
          {selected.length === 0 ? '—' : preview}
        </span>
        <span className="map-selection-count">({selected.length})</span>
      </div>
      <div className="map-selection-actions">
        <button
          type="button"
          className="map-selection-cancel"
          onClick={onCancel}
          data-testid="map-selection-cancel"
        >
          Отмена
        </button>
        <button
          type="button"
          className="map-selection-confirm"
          onClick={onConfirm}
          data-testid="map-selection-confirm"
        >
          Готово →
        </button>
      </div>
    </footer>
  );
}
